// extracted by mini-css-extract-plugin
export default {"mapInfoBox":"style_mapInfoBox__xP6YS"};